var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 46,
    r: 46,
    fill: "#131313"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.7,33.1,48.7,67l-18-16.7a1.981,1.981,0,0,1,2.7-2.9L48,60.9,68.4,30.8a2.05,2.05,0,0,1,2.8-.5A2.173,2.173,0,0,1,71.7,33.1Z",
    transform: "translate(-4 -4)",
    fill: "#f7f7f7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.464772a5bef3da731c3ce9b6d1d469d4.svg";
export { ForwardRef as ReactComponent };